var FieldTypes;
(function (FieldTypes) {
    FieldTypes["string"] = "string";
    FieldTypes["enum"] = "enum";
    FieldTypes["int"] = "int";
    FieldTypes["boolean"] = "boolean";
    FieldTypes["long"] = "long";
    FieldTypes["float"] = "float";
    FieldTypes["timestamp"] = "timestamp";
    FieldTypes["timestampHighRes"] = "timestamp_high_res";
    FieldTypes["array"] = "array";
    FieldTypes["ip"] = "ip";
})(FieldTypes || (FieldTypes = {}));
function isNil(value) {
    return value === undefined || value === null || Number.isNaN(value);
}
function isNilOrEmptyString(value) {
    return isNil(value) || value === "";
}
function isTypeTimestamp(type) {
    return type === FieldTypes.timestamp || type === FieldTypes.timestampHighRes;
}
function getStart(word, index) {
    let i = index - 1;
    for (i; i >= 0; i--) {
        if (word.charAt(i) === " ") {
            return i + 1;
        }
    }
    return 0;
}

export { FieldTypes, getStart, isNil, isNilOrEmptyString, isTypeTimestamp };
//# sourceMappingURL=utils.esm.js.map
